import { apiRequest } from "../index";

export const getAllSubAdmins = async ({ page = 1, limit = 10 }) => {
  return apiRequest(`/api/common/sub-admin?page=${page}&limit=${limit}`, "GET");
};

export const getSubAdminById = async (subadminId) => {
  return apiRequest(`/api/common/sub-admin/${subadminId}`, "GET");
};

export const updateSubAdmin = async (subadminId, data) => {
  return apiRequest(`/api/common/sub-admin/${subadminId}`, "PUT", data);
};

export const addSubAdmin = async (data) => {
  return apiRequest(`/api/common/sub-admin`, "POST", data);
};

export const deleteSubAdmin = async ( subadminId) => {
  return apiRequest(`/api/common/sub-admin/${subadminId}`, "DELETE");
};

